import { CurrentDataSourceStatusResponse, DataSourceStatusSerializable } from 'com.cogvio.pricemonitor.api';
import React from 'react';
import { formatHumanDate } from '~/DateTime';
import CountryIcon from '~/UI/CountryIcon/CountryIcon';

export const Types = {
	upToDate: 'up-to-date',
	processing: 'processing',
	caution: 'caution',
};

interface Props {
	status: CurrentDataSourceStatusResponse;
}

export const statusType = (type: DataSourceStatusSerializable) => {
	switch (type) {
		case Types.upToDate:
			return (
				<p className='xs:absolute left-0 top-0 pt-px w-24 h-6 rounded-sm leading-6 font-semibold text-labelsmall text-white text-center bg-green-600'>
					UP TO DATE
				</p>
			);
		case Types.processing:
			return (
				<p className='xs:absolute left-0 top-0 pt-px w-24 h-6 rounded-sm leading-6 font-semibold text-labelsmall text-white text-center bg-orange-600'>
					PROCESSING
				</p>
			);
		case Types.caution:
			return (
				<p className='xs:absolute left-0 top-0 pt-px w-24 h-6 rounded-sm leading-6 font-semibold text-labelsmall text-white text-center bg-orange-600'>
					RECONSTRUCTION
				</p>
			);
		default:
			return null;
	}
};

export function Detail({ status }: Props) {
	const lastUpdateDate = status.lastUpdateAt !== null ? formatHumanDate(new Date(status.lastUpdateAt)) : '';

	return (
		<div className='px-3 py-4 flex sm:flex-row flex-col justify-between items-start'>
			<div className='relative xs:pl-28'>
				{statusType(status.type)}
				<p className='xs:pt-0.5 pt-2 flex justify-start items-center text-lg font-semibold leading-5 text-cPurple-600 tracking-wide'>
					<span className='w-5 h-5 mr-2'>
						<CountryIcon code={status.dataSource.country.alpha2} name={status.dataSource.country.name} />
					</span>
					{status.dataSource.country.name}
					{' - '}
					{status.dataSource.shortName}
				</p>
				<p className='mt-1 xs:pl-7 text-md leading-normal text-gray-500'>{status.dataSource.description}</p>
			</div>
			<div className='pt-0.5 sm:pl-5 xs:pl-28 sm:text-right text-left shrink-0 grow-0 text-md'>
				<p className='sm:pl-0 xs:pl-7 leading-5 text-gray-400'>
					Last update date:
					<strong className='block sm:mt-1.5 mt-0.5 font-semibold text-gray-800'>{lastUpdateDate}</strong>
				</p>
			</div>
		</div>
	);
}
